import { useContext } from "react";
import { EditorNavPage, NavPage } from "../../services/NavService";
import { EditorContext } from "../EditorCommon/EditorContext";
import "./EditorNav.scss"


/** Goes inside a TopNav for navigating the editor */
export function EditorNav(props: {
    currentPage: EditorNavPage;
    nextButton?: JSX.Element;
}) {

    const ec = useContext(EditorContext);


    function navigate(np: EditorNavPage) {
        ec.navService.canNavigateTo(np)
            && ec.navService.navigate(np);
    }

    function getClassName(np: EditorNavPage): string {
        const classes = [
            "nav-link",
        ];
        if (np === props.currentPage) {
            classes.push("active");
        }

        if (!ec.navService.canNavigateTo(np)) {
            classes.push("disabled");
        }
        if (np.hasErrors(ec.cabinetService)) {
            classes.push("error");
        }

        return classes.join(" ");
    }


    const prevPage = ec.navService.prev(props.currentPage);
    const prevValid = ec.navService.canNavigateTo(prevPage);

    const nextPage = ec.navService.next(props.currentPage);
    const nextValid = ec.navService.canNavigateTo(nextPage);

    const nextButton = props.nextButton ?? (
            <button className="nav-btn-forward btn btn-primary"
                onClick={() => nextValid && ec.navService.navigate(nextPage!)}
                disabled={!nextValid}
                data-invalid={!nextPage}
            >
                {ec.translator("editorNav forward", "Næste")}
            </button>
        );

    return (
        <nav className="navbar navbar-expand-md editor-nav">
            <div className="nav-back">
                <button className="nav-btn nav-link nav-btn-back"
                    onClick={() => prevValid && ec.navService.navigate(prevPage!)}
                    disabled={!prevValid}
                    data-invalid={!prevPage}
                >
                    {ec.translator("editorNav back", "Forrige")}
                </button>
            </div>

            <ul className="nav navbar-nav routes-nav ">
                {NavPage.EditorPages.map(p => (
                    <li className="nav-item" key={p.url}>
                        <span className={getClassName(p)}
                            onClick={() => navigate(p)}
                        >
                            {ec.translator(p)}
                        </span>
                    </li>
                ))}
            </ul>

            <div className="nav-forward">
                {nextButton}
            </div>
        </nav>
    );
}

